import { buildExps } from "./regexps-uri";
export default buildExps(true);
//# sourceMappingURL=regexps-iri.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/uri-js/dist/esnext/regexps-iri.js
// module id = 1579
// module chunks = 0